import produce from 'immer';
import React from 'react';
import { Assignee, MutualActionPlan, MutualActionPlanItem } from 'src/common/interfaces/mutual_action_plan.interface';
import { DeleteRegularIcon } from 'src/monet/icons';
import { ContextMenuButton } from './components/context-menu-button';
import { useEditorStore } from './editor-store';

type Props = {
  item: MutualActionPlanItem;
  mutualActionPlan: {
    uuid: MutualActionPlan['uuid'];
  };
  assignee: Assignee;
};

function removeAssignee(item: MutualActionPlanItem, assignee: Assignee): MutualActionPlanItem {
  return produce(item, (item) => {
    item.assigned_to = item.assigned_to.filter((a) => {
      if (assignee.email) {
        return a.email !== assignee.email || a.name !== assignee.name;
      } else {
        return a.name !== assignee.name;
      }
    });
  });
}

export const MutualActionPlanItemAssigneeContextMenuContent = ({ item, mutualActionPlan, assignee }: Props) => {
  const dispatchUserEditorAction = useEditorStore((state) => state.dispatchUserEditorAction);
  const clearContextMenuState = useEditorStore((state) => state.clearContextMenuState);

  const onDeleteTask = () => {
    dispatchUserEditorAction({
      type: 'update-mutual-action-plan-item',
      item: removeAssignee(item, assignee),
      mutualActionPlan: mutualActionPlan,
    });
    clearContextMenuState();
  };

  return (
    <>
      <ContextMenuButton onClick={onDeleteTask} label='Delete assignee'>
        <DeleteRegularIcon className='text-inherit' />
      </ContextMenuButton>
    </>
  );
};
